import React, { FC } from "react";

const Home: FC = () => {
  return (
    <div>
      <h1 className="text-black-800 text-4xl" style={{marginLeft: 10}}>Panel administratora licencji zawodniczych</h1>
    </div>
  );
};

export default Home;
